import { PayrollFundingMethodType } from "../../Settings/components/funding/FlowAddFundingMethod";

// A single SDK id can map to multiple internal method types — "wallet"
// resolves to every wallet currency currently offered.
const SDK_ID_TO_INTERNAL: Record<string, PayrollFundingMethodType[]> = {
  ach: ["ach"],
  wallet: ["wallet-usd", "wallet-cad", "wallet-pln"]
};

export const parseAllowedFundingMethods = (
  queryParam: string
): PayrollFundingMethodType[] => {
  const result: PayrollFundingMethodType[] = [];

  queryParam
    .split(",")
    .map(value => value.trim())
    .filter(Boolean)
    .forEach(value => {
      const mapped = SDK_ID_TO_INTERNAL[value];
      if (mapped) {
        mapped.forEach(internal => {
          if (!result.includes(internal)) {
            result.push(internal);
          }
        });
      }
    });

  return result;
};
